/*
 * サブシステム名
 * 機能名：日報入力
 * 表示項目カスタマイズ(光陽テクノサービス)
 */

import D2PRMD0021 from '@/views/PRM/D2PRMD0021.js'

import d2fmt from '@/ddv2.library/utils/formatter'
import filter from '@/rahmen/utils/filters'
import indexeddb from '@/ddv2.library/indexeddb'
// import dayjs from 'dayjs'
// import tax from '@/ddv2.library/tax'

export default ({
  extends: D2PRMD0021,
  name: 'NippoEditCustomForKts',
  data: () => ({
    haisoMeisaiListHeaders: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: '操作', value: 'actions', width: '155px', sortable: false },
      { text: '#', value: 'meisaiOrder', width: '40px' },
      { text: '請求年月日', value: 'dispSeikyuYoteiYmd', align: 'center' },
      { text: '得意先', value: 'dispTokuisaki' },
      { text: '積地', value: 'dispHatsuchi' },
      { text: '卸地', value: 'dispChakuchi' },
      { text: '配送内容', value: 'dispHinmei' },
      { text: '請求金額', value: 'dispSeikyuKingaku', align: 'right' },
      { text: '支払金額', value: 'dispShiharaiKingaku', align: 'right' },
      { text: '注文番号', value: 'chumonNo' }
    ]
  }),
  computed: {
    unchinKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let hokanKingaku = this.recHaisoMeisai.hokanKingaku
      let niekiKingaku = this.recHaisoMeisai.niekiKingaku
      let unchinHokaKingaku = this.recHaisoMeisai.unchinHokaKingaku
      let nenryoSurcharge = this.recHaisoMeisai.nenryoSurcharge
      let tsumikomiKingaku = this.recHaisoMeisai.tsumikomiKingaku
      let torioroshiKingaku = this.recHaisoMeisai.torioroshiKingaku
      let taikiJikanKingaku = this.recHaisoMeisai.taikiJikanKingaku
      let futaiGyomuKingaku = this.recHaisoMeisai.futaiGyomuKingaku
      let futaiGyomuKingaku1 = this.recHaisoMeisai.futaiGyomuKingaku1
      let futaiGyomuKingaku2 = this.recHaisoMeisai.futaiGyomuKingaku2
      let userKingakuKazei5 = this.recHaisoMeisai.userKingakuKazei5
      let userKingakuKazei6 = this.recHaisoMeisai.userKingakuKazei6
      let futaiGyomuKingaku3 = this.recHaisoMeisai.futaiGyomuKingaku3
      let userKingakuKazei7 = this.recHaisoMeisai.userKingakuKazei7
      let warimashiSonotaKingsku = this.recHaisoMeisai.warimashiSonotaKingsku
      let userKingakuKazei10 = this.recHaisoMeisai.userKingakuKazei10

      if (hokanKingaku === undefined || hokanKingaku === '' || hokanKingaku === null) { hokanKingaku = '0' }
      if (niekiKingaku === undefined || niekiKingaku === '' || niekiKingaku === null) { niekiKingaku = '0' }
      if (unchinHokaKingaku === undefined || unchinHokaKingaku === '' || unchinHokaKingaku === null) { unchinHokaKingaku = '0' }
      if (nenryoSurcharge === undefined || nenryoSurcharge === '' || nenryoSurcharge === null) { nenryoSurcharge = '0' }
      if (tsumikomiKingaku === undefined || tsumikomiKingaku === '' || tsumikomiKingaku === null) { tsumikomiKingaku = '0' }
      if (torioroshiKingaku === undefined || torioroshiKingaku === '' || torioroshiKingaku === null) { torioroshiKingaku = '0' }
      if (taikiJikanKingaku === undefined || taikiJikanKingaku === '' || taikiJikanKingaku === null) { taikiJikanKingaku = '0' }
      if (futaiGyomuKingaku === undefined || futaiGyomuKingaku === '' || futaiGyomuKingaku === null) { futaiGyomuKingaku = '0' }
      if (futaiGyomuKingaku1 === undefined || futaiGyomuKingaku1 === '' || futaiGyomuKingaku1 === null) { futaiGyomuKingaku1 = '0' }
      if (futaiGyomuKingaku2 === undefined || futaiGyomuKingaku2 === '' || futaiGyomuKingaku2 === null) { futaiGyomuKingaku2 = '0' }
      if (hokanKingaku === undefined || hokanKingaku === '' || hokanKingaku === null) { hokanKingaku = '0' }
      if (userKingakuKazei7 === undefined || userKingakuKazei7 === '' || userKingakuKazei7 === null) { userKingakuKazei7 = '0' }
      if (warimashiSonotaKingsku === undefined || warimashiSonotaKingsku === '' || warimashiSonotaKingsku === null) { warimashiSonotaKingsku = '0' }
      if (userKingakuKazei5 === undefined || userKingakuKazei5 === '' || userKingakuKazei5 === null) { userKingakuKazei5 = '0' }
      if (userKingakuKazei6 === undefined || userKingakuKazei6 === '' || userKingakuKazei6 === null) { userKingakuKazei6 = '0' }
      if (futaiGyomuKingaku3 === undefined || futaiGyomuKingaku3 === '' || futaiGyomuKingaku3 === null) { futaiGyomuKingaku3 = '0' }
      if (userKingakuKazei10 === undefined || userKingakuKazei10 === '' || userKingakuKazei10 === null) { userKingakuKazei10 = '0' }

      let amount = 0

      amount = parseInt(this.calcUnchin, 10) +
                parseInt(taikiJikanKingaku, 10) +
                parseInt(futaiGyomuKingaku1, 10) +
                parseInt(futaiGyomuKingaku2, 10) +
                parseInt(tsumikomiKingaku, 10) +
                parseInt(userKingakuKazei5, 10) +
                parseInt(userKingakuKazei6, 10) +
                parseInt(futaiGyomuKingaku3, 10) +
                parseInt(hokanKingaku, 10) +
                parseInt(userKingakuKazei7, 10) +
                parseInt(unchinHokaKingaku, 10) +
                parseInt(warimashiSonotaKingsku, 10) +
                parseInt(userKingakuKazei10, 10)

      return amount
    },
    // 配送明細フィルター --> ここから
    filteredHaisoMeisaiListRows () {
      // データがない場合の制御
      if (!this.viewsData.vwHaisoMeisai.map) { return }

      return this.viewsData.vwHaisoMeisai.map((elem, index) => {
        // 行番号
        elem.rowNo = index + 1

        elem.dispHatsuchi = ''
        elem.dispChakuchi = ''
        elem.dispHinmei = ''

        if (elem.meisaiOrder) { elem.meisaiOrder = Number(elem.meisaiOrder) }
        if (elem.tokuisakiId) {
          const record = indexeddb.getRecord(this.torihikisakiList, elem.tokuisakiId)
          elem.dispTokuisaki = record ? record.torihikisakiNm : ''
        }
        if (![undefined, null, ''].includes(elem.hatsuchiId)) {
          const record = indexeddb.getRecord(this.hacchakuchiList, elem.hatsuchiId)
          elem.dispHatsuchi = record ? record.hacchakuchiNm : ''
        }
        if (![undefined, null, ''].includes(elem.hatsuchiBiko)) { elem.dispHatsuchi = elem.dispHatsuchi + (elem.dispHatsuchi !== '' ? ' ' : '') + elem.hatsuchiBiko }
        if (elem.hatsuchiYmd || elem.hatsuchiHms) { elem.dispHatsuchiYmd = !elem.hatsuchiYmd ? elem.hatsuchiHms : !elem.hatsuchiHms ? elem.hatsuchiYmd : elem.hatsuchiYmd + ' ' + elem.hatsuchiHms }
        if (elem.hatsuchiHmsBiko && !(elem.hatsuchiYmd || elem.hatsuchiHms)) { elem.dispHatsuchiYmd = elem.hatsuchiHmsBiko }
        if (![undefined, null, ''].includes(elem.chakuchiId)) {
          const record = indexeddb.getRecord(this.hacchakuchiList, elem.chakuchiId)
          elem.dispChakuchi = record ? record.hacchakuchiNm : ''
        }
        if (![undefined, null, ''].includes(elem.chakuchiBiko)) { elem.dispChakuchi = elem.dispChakuchi + (elem.dispChakuchi !== '' ? ' ' : '') + elem.chakuchiBiko }
        if (elem.chakuchiYmd || elem.chakuchiHms) { elem.dispChakuchiYmd = !elem.chakuchiYmd ? elem.chakuchiHms : !elem.chakuchiHms ? elem.chakuchiYmd : elem.chakuchiYmd + ' ' + elem.chakuchiHms }
        if (elem.chakuchiHmsBiko && !(elem.chakuchiYmd || elem.chakuchiHms)) { elem.dispChakuchiYmd = elem.chakuchiHmsBiko }
        if (![undefined, null, ''].includes(elem.mstHinmeiId)) {
          const record = indexeddb.getRecord(this.hinmeiList, elem.mstHinmeiId)
          elem.dispHinmei = record ? record.hinmeiNm : ''
        }
        if (![undefined, null, ''].includes(elem.hinmeiBiko)) { elem.dispHinmei = elem.dispHinmei + (elem.dispHinmei !== '' ? ' ' : '') + elem.hinmeiBiko }
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericMinorDigitFormatter(elem.juchuSuryo, 3) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericMinorDigitFormatter(elem.juchuJuryo, 3) }
        if (elem.seikyuYoteiYmd) { elem.dispSeikyuYoteiYmd = elem.seikyuYoteiYmd }

        // 基本運賃
        let amount = 0
        let tanka = 0
        if (elem.tanka) { tanka = elem.tanka }
        if (elem.unchinKeisanKbn === '01') {
          let juchuSuryo = elem.juchuSuryo
          if (juchuSuryo === undefined || juchuSuryo === '' || juchuSuryo === null) { juchuSuryo = '0' }
          juchuSuryo = d2fmt.removeComma(juchuSuryo)
          amount = parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
        } else if (elem.unchinKeisanKbn === '02') {
          let juchuJuryo = elem.juchuJuryo
          if (juchuJuryo === undefined || juchuJuryo === '' || juchuJuryo === null) { juchuJuryo = '0' }
          juchuJuryo = d2fmt.removeComma(juchuJuryo)
          amount = parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
        } else if (elem.unchinKeisanKbn === '03') {
          amount = parseFloat(tanka, 10)
        }
        if (elem.hiwayPrice) { amount += parseFloat(elem.hiwayPrice, 10) }
        if (elem.taikiJikanKingaku) { amount += parseFloat(elem.taikiJikanKingaku, 10) }
        if (elem.futaiGyomuKingaku1) { amount += parseFloat(elem.futaiGyomuKingaku1, 10) }
        if (elem.futaiGyomuKingaku2) { amount += parseFloat(elem.futaiGyomuKingaku2, 10) }
        if (elem.tsumikomiKingaku) { amount += parseFloat(elem.tsumikomiKingaku, 10) }
        if (elem.userKingakuKazei5) { amount += parseFloat(elem.userKingakuKazei5, 10) }
        if (elem.userKingakuKazei6) { amount += parseFloat(elem.userKingakuKazei6, 10) }
        if (elem.futaiGyomuKingaku3) { amount += parseFloat(elem.futaiGyomuKingaku3, 10) }
        if (elem.hokanKingaku) { amount += parseFloat(elem.hokanKingaku, 10) }
        if (elem.userKingakuKazei7) { amount += parseFloat(elem.userKingakuKazei7, 10) }
        if (elem.unchinHokaKingaku) { amount += parseFloat(elem.unchinHokaKingaku, 10) }
        if (elem.unchinHokaHikazei) { amount += parseFloat(elem.unchinHokaHikazei, 10) }
        if (elem.warimashiSonotaKingsku) { amount += parseFloat(elem.warimashiSonotaKingsku, 10) }
        if (elem.userKingakuKazei10) { amount += parseFloat(elem.userKingakuKazei10, 10) }
        elem.dispSeikyuKingaku = filter.numericFormatter(amount)
        let payAmount = 0
        if (elem.yoshaKihonUnchin) { payAmount += parseFloat(elem.yoshaKihonUnchin, 10) }
        if (elem.yoshaHiwayPrice) { payAmount += parseFloat(elem.yoshaHiwayPrice, 10) }
        if (elem.yoshaUnchinHokaKingaku) { payAmount += parseFloat(elem.yoshaUnchinHokaKingaku, 10) }
        if (elem.yoshaUnchinHokaHikazei) { payAmount += parseFloat(elem.yoshaUnchinHokaHikazei, 10) }
        elem.dispShiharaiKingaku = filter.numericFormatter(payAmount)
        elem.dispChumonshoReceiveZumiFlg = elem.chumonshoReceiveZumiFlg ? '受領済' : ''
        elem.dispChumonkakuninshoSendZumiFlg = elem.chumonkakuninshoSendZumiFlg ? '送付済' : ''
        elem.dispHacchushoSendZumiFlg = elem.hacchushoSendZumiFlg ? '送付済' : ''
        elem.dispMotoukeHokokuZumiFlg = elem.motoukeHokokuZumiFlg ? '報告済' : ''
        return elem
      }).sort((a, b) => {
        if (a.meisaiOrder > b.meisaiOrder) { return 1 }
        if (a.meisaiOrder === b.meisaiOrder) { return 0 }
        return -1
      })
    },
    seikyuKingakuSummary () {
      let amount = 0
      this.viewsData.vwHaisoMeisai.map((elem) => {
        let tanka = 0
        if (elem.tanka) { tanka = elem.tanka }
        if (elem.unchinKeisanKbn === '01') {
          let juchuSuryo = elem.juchuSuryo
          if ([undefined, null, ''].includes(juchuSuryo)) { juchuSuryo = '0' }
          juchuSuryo = d2fmt.removeComma(juchuSuryo)
          amount += parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
        } else if (elem.unchinKeisanKbn === '02') {
          let juchuJuryo = elem.juchuJuryo
          if ([undefined, null, ''].includes(juchuJuryo)) { juchuJuryo = '0' }
          juchuJuryo = d2fmt.removeComma(juchuJuryo)
          amount += parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
        } else if (elem.unchinKeisanKbn === '03') {
          amount += parseFloat(tanka, 10)
        }
        if (elem.hiwayPrice) { amount += parseFloat(elem.hiwayPrice, 10) }
        if (elem.taikiJikanKingaku) { amount += parseFloat(elem.taikiJikanKingaku, 10) }
        if (elem.futaiGyomuKingaku1) { amount += parseFloat(elem.futaiGyomuKingaku1, 10) }
        if (elem.futaiGyomuKingaku2) { amount += parseFloat(elem.futaiGyomuKingaku2, 10) }
        if (elem.tsumikomiKingaku) { amount += parseFloat(elem.tsumikomiKingaku, 10) }
        if (elem.userKingakuKazei5) { amount += parseFloat(elem.userKingakuKazei5, 10) }
        if (elem.userKingakuKazei6) { amount += parseFloat(elem.userKingakuKazei6, 10) }
        if (elem.futaiGyomuKingaku3) { amount += parseFloat(elem.futaiGyomuKingaku3, 10) }
        if (elem.hokanKingaku) { amount += parseFloat(elem.hokanKingaku, 10) }
        if (elem.userKingakuKazei7) { amount += parseFloat(elem.userKingakuKazei7, 10) }
        if (elem.userKingakuKazei10) { amount += parseFloat(elem.userKingakuKazei10, 10) }
        if (elem.unchinHokaKingaku) { amount += parseFloat(elem.unchinHokaKingaku, 10) }
        if (elem.unchinHokaHikazei) { amount += parseFloat(elem.unchinHokaHikazei, 10) }
        if (elem.warimashiSonotaKingsku) { amount += parseFloat(elem.warimashiSonotaKingsku, 10) }
      })
      return filter.numericFormatter(amount)
    }
  },
  methods: {
  }
})
